import * as React from 'react';
import { GuestUser } from './User/GuestUser';
import { IUser } from './User/IUser';

export const CurrentUserContext = React.createContext({
  setWorkingFrom: (v: string) => {
    return
  },
  user: new GuestUser() as IUser,
});